module.exports = __webpack_public_path__ + "img/turkish_eggs_base.6d05ffb6.jpg";